export const LOAN_WORKFLOW_CONTAINER_TAG_NAME = 'loan-workflow-container';
